import * as React from 'react';
import { UIState } from 'data/UIState';

import './ads.pcss';
import {BundleData} from "data/BundleData";

const AdLink = (props:{ad:any, user:any, className?:string}) => {
	let link = props.ad.externalLink;
	
	if(link) {
		link = link.replace(/{{email}}/g, props.user.email);
		link = link.replace(/{{pickATimeVenueId}}/g, UIState.pickATimeVenueId);
	} else {
		link="#";
	}
	return(
		<div className={`${props.className?props.className:'ads'}`}>
			<a href={link} target="_blank"><img alt={props.ad.altText} src={props.ad.imagePath} /></a>
		</div>
	);
}

const AdBundle = (props:{ad:any, className?:string, onSetCurrentPage:(page:string|null)=>void}) => {
	const handleSelectBundle = () => {
		BundleData.selectedBundleId = props.ad.bundleId;
		props.onSetCurrentPage('booth');
		return false;
	}
	return (
		<div className={`${props.className ? props.className : 'ads'}`}>
			<a onClick={handleSelectBundle} target="_blank"><img alt={props.ad.altText} src={props.ad.imagePath}/></a>
		</div>
	)
};

const AdDocument = (props:{ad:any, className?:string}) =>
	<div className={`${props.className?props.className:'ads'}`}>
		<a href={props.ad.documentPath} target="_blank"><img alt={props.ad.altText} src={props.ad.imagePath} /></a>
	</div>
;

const AdPlain = (props:{ad:any, className?:string}) =>
	<div className={`${props.className?props.className:'ads'}`}>
		<img alt={props.ad.altText} src={props.ad.imagePath}/>
	</div>
;


interface Props {
	ads:Array<any>;
	user:any;
	handleSetCurrentPage:(page:string|null)=>void;
}

const HorizontalAds = (props:Props) => {




	if(props.ads.length) {		
		const ad = props.ads[0];
		if(ad.type==='document') {
			return <AdDocument ad={ad} className='hzad doc' />;
		} else if(ad.type==='link') {
			return <AdLink ad={ad} user={props.user} className='hzad link' />;
		} else if(ad.type==='plain') {
			return <AdPlain ad={ad} className='hzad plain' />;
		} else if(ad.type==='bundle') {
			return <AdBundle ad={ad} className='hzad bundle' onSetCurrentPage={props.handleSetCurrentPage} />;
		} else {
			return null;
		}
	} else {
		return null;
	}
};



export { HorizontalAds };



